import React from 'react'

import FlatButton from 'material-ui/FlatButton'
import FileDownloadIcon from 'material-ui/svg-icons/file/file-download'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import CircularProgress from 'material-ui/CircularProgress'

class ExportActions extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  handleTouchTap = event => {
    event.preventDefault()

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    })
  }

  handleRequestClose = () => {
    this.setState({
      open: false
    })
  }

  handleExport = (option, event) => {
    event.preventDefault()

    this.setState({
      open: false
    })

    this.props.handleExport(option)
  }

  render () {
    const { options, isExporting } = this.props

    if (!options.length) return null

    if (isExporting) {
      return <FlatButton
        disabled
        icon={<CircularProgress size={20} color='#000000' />}
      />
    }

    if (options.length === 1) {
      return <FlatButton
        onClick={this.handleExport.bind(this, options[0])}
        icon={<FileDownloadIcon />}
        title='Export CSV'
      />
    }

    return (
      <div style={{ display: 'inline' }}>
        <FlatButton
          title='Export'
          icon={<FileDownloadIcon />}
          onClick={this.handleTouchTap}
        />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            {
              this.props.options.map(option => (
                <MenuItem
                  key={option.label}
                  primaryText={option.label}
                  onClick={this.handleExport.bind(this, option)}
                />
              ))
            }
          </Menu>
        </Popover>
      </div>
    )
  }
}

// @ts-ignore
ExportActions.propTypes = {
  options: React.PropTypes.array,
  isExporting: React.PropTypes.bool,
  handleExport: React.PropTypes.func.isRequired
}

// @ts-ignore
ExportActions.defaultProps = {
  options: []
}

export default ExportActions
